import type { FiltersPolishAssignment } from '@typings/experiments';
import type { State } from 'types/redux';
import { selectAssignment } from '.';

const filtersPolishSelector = (state: State) => {
	return (selectAssignment(state, ['filtersPolish']) ??
		null) as FiltersPolishAssignment;
};

const isInFiltersPolishExperiment = (state: State) => {
	return filtersPolishSelector(state) === 'variant1';
};

export { filtersPolishSelector, isInFiltersPolishExperiment };
